import React from 'react';
import { View } from 'react-native';

import FeedbackIconButton from './feedback-icon-button';
import styles from './feedback-response.style';
import { isBigScreen } from '../../../components/media-query';
import { useColors } from '../../../hooks';

interface FeedbackResponseProps {
  icon?;
  onClose: () => void;
  children?: React.ReactNode;
}

function FeedbackResponse({ icon, onClose, children }: FeedbackResponseProps) {
  const colors = useColors();

  return (
    <View style={[styles.container, { backgroundColor: colors.grayLight }]}>
      {isBigScreen() && (
        <View style={styles.closeButtonContainer}>
          <FeedbackIconButton
            iconName="times"
            iconSize={16}
            onPress={onClose}
          />
        </View>
      )}
      <View style={styles.innerContainer}>
        <View style={styles.textIconContainer}>
          {icon && (
            <View
              style={[
                styles.iconBubble,
                { backgroundColor: colors.background },
              ]}
            >
              {icon}
            </View>
          )}

          {children}
        </View>
      </View>
    </View>
  );
}

export default FeedbackResponse;
